import { LocationSchema, LocationsSchema, CreateLocationFromGooglePlaceSchema } from './schema';
import type { CreateLocationFromGooglePlaceParams, GetLocationsParams } from './types';
import { HTTP_METHOD } from '../../consts';
import { serializeRequestBody } from '../../serializer';
import type { ApiCallOptions, Transport } from '../../types';

export const createLocationsApi = (transport: Transport) => ({
  getLocations: (params?: GetLocationsParams, options?: ApiCallOptions) => {
    const { page, numPerPage, query } = params ?? {};

    const queryParams = {
      ...(page !== undefined && { page }),
      ...(numPerPage !== undefined && { num_per_page: numPerPage }),
      ...(query?.trim() && { query: query.trim() })
    };

    return transport('/manage/v1/locations', {
      method: HTTP_METHOD.GET,
      deserializer: LocationsSchema,
      queryParams,
      signal: options?.signal
    });
  },
  getLocation: (locationId: number, options?: ApiCallOptions) =>
    transport(`/manage/v1/locations/${locationId}`, {
      method: HTTP_METHOD.GET,
      deserializer: LocationSchema,
      signal: options?.signal
    }),
  createLocationFromGooglePlace: (
    { placeId, pureServiceAreaBusiness, geoLocation, status, overrides }: CreateLocationFromGooglePlaceParams,
    options?: ApiCallOptions
  ) =>
    transport('/manage/v1/locations/actions/create-from-place-id', {
      method: HTTP_METHOD.POST,
      body: serializeRequestBody({
        placeId,
        isServiceAreaBusiness: pureServiceAreaBusiness,
        ...(geoLocation && { latitude: geoLocation.latitude, longitude: geoLocation.longitude }),
        ...overrides,
        ...(status && { status })
      }),
      deserializer: CreateLocationFromGooglePlaceSchema,
      signal: options?.signal
    })
});

export type LocationsApi = ReturnType<typeof createLocationsApi>;
